import { MappedAEMProperties } from '../../../../types';
import { useDevice } from '../../../../lib/hooks/device';
import { useLearning } from '../../../../lib/api/swrApi';
import { useId } from '../../../../lib/hooks/useId';
import { ApiSwrGetResponse } from '../../../../lib/api/apiConfig';
import LatestTrainingListView from '../../base/LatestTrainingListView/LatestTrainingListView';
import SkeletonCarousel from '../../base/Carousel/SkeletonCarousel';
import ErrorInfo from '../../base/ErrorInfo/ErrorInfo';
import { Api } from '../../../../lib/types/apiSpec';

export interface LatestTrainingListProps extends MappedAEMProperties {
  heading?: string;
  limit?: number;
}

export const validateAndMapData = (data: NonNullable<ApiSwrGetResponse<'/learning'>>) => {
  return data
    ?.filter(({ type }) => ![type].includes(undefined))
    .map(({ id, type, name = '', description = '', duration, url = '', originalId, ...rest }) => ({
      ...rest,
      id,
      type: type as Api.TrainingType,
      name,
      description,
      duration,
      href: url,
      originalId,
    }));
};

const LatestTrainingList = ({ heading, limit = 6, id }: LatestTrainingListProps) => {
  const device = useDevice();
  const { data, isValidating, error } = useLearning(device === 'desktop' ? limit : Math.min(limit, 6));
  const componentId = id ?? useId('latest-training-');

  if (!data?.length && isValidating) {
    return <SkeletonCarousel />;
  }

  if (error) {
    return <ErrorInfo error={error} />;
  }

  if (data === undefined || !data.length) {
    return null;
  }

  const items = validateAndMapData(data);

  return <LatestTrainingListView id={componentId} title={heading} items={items ?? []} />;
};

export default LatestTrainingList;
